
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/portfolio",
      function () {
        return require("private-next-pages/user/portfolio/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/portfolio"])
      });
    }
  